import * as helper from "./helper"
import * as aes from "../../utils/aes"
import * as request from "../../utils/request"
import { LoginSession } from "./store/apple-gift-card/getters"
import { UserRole, UserZone } from "./store/apple-gift-card/state"

export function rechargeCard<T>(params: { sandbox: string; offerId: string } & LoginSession): Promise<T> {
  return new Promise((resolve, reject) => {
    const env = helper.getCgiEnv(params.sandbox)
    const rawData = {
      from_https: 1,
      from_h5: 1,
      pf: "mds_wechat_qb-pay_html5-html5",
      pfkey: "pfkey"
    }

    const data = Object.assign(
      rawData,
      aes.encrypt(params as any, ["product_id", "drm_info", "openid", "openkey", "session_id", "session_type"], !!params.sandbox),
      params
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/apple_store_recharge_card`,
        data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res as T)
        } else {
          reject(res as T)
        }
      })
      .catch(res => {
        reject(res as Error | XMLHttpRequest)
      })
  })
}

export interface MobileSaveGoodsParams extends LoginSession, Record<string, string | undefined> {
  sandbox: string
  mid: string
  offerId: string
  pf: string
  token_id: string
  groupid?: string
  pay_method: string
  codeId?: string
  batchId?: string
  sp_info?: string
  drm_info?: string
}
export interface MobileSaveGoodsResponseBody {
  ret: number
  err_code: string
  msg: string
  flex_attack_info: {
    fk_info: string
    verify_url: string
    fk_amt: string
  }
  info: {
    billno: string
    channel_info: string
    count: number
    mburl: string
    sms_info: string
    remain: number
    cfturl: string
    mcardserialno: string
    verifycode: string
    verifysession: string
    qkbalance: string
    mcard_balance: string
    qqacct_difference: string
    success_url: string
    mb_only_sms: string
    need_change_key: number
    portal_serial_no: string
    is_allow_change: string
    user_msg: string
    comm_config: Record<string, unknown>
  }
  wx_info: {
    wx_token: string
    wx_partner: string
    wx_appid: string
    wx_time: string
    wx_noncenum: string
    wx_sign: string
    wx_package: string
    wx_signtype: string
    wx_productid: string
    wx_sign_url: string
    wx_serialno: string
    wx_ret_code: string
    wx_ret_errmsg: string
  }
  hf_info: {
    tips: string
    vtype: string
    province: string
    billno: string
    channel: string
    price: string
    hfpay_pay_flow: string
    hf_interfacetype: string
    hfpay_url: string
    outOrderId: string
    solutionType: string
    contentId: string
    channelId: string
    itemIndex: string
    hfpay_channelInfo: string
    accessnum: string
    accessmsg: string
    hf_extend: string
  }
  qqwallet_info: {
    qqwallet_order_id: string
    qqwallet_appId: string
    qqwallet_nonce: string
    qqwallet_tokenId: string
    qqwallet_pubAcc: string
    qqwallet_bargainorId: string
    qqwallet_sigType: string
    qqwallet_sig: string
    qqwallet_timestamp: string
    qqwallet_seq: string
    qq_sign_url: string
  }
  sp_info: {
    drm_goldcoupons_acct: string
    channel_orderid: string
    out_trade_no: string
  }
  remitpay_info: string
  rc_info: {
    rc_type: string
    rc_msg: string
    rc_amt: string
    rc_policyid: string
  }
  wechatapp_info: {
    price_level: string
    orderid: string
    desc: string
    sign: string
  }
}
export interface TaskProcessQueryBodyInfo {
  task_id: string
  origin: string
  origin_type: string
  nick_img: string
  cgi_data: string
  present_rank: string
  task_status: string
  task_token: string
  total_score: string
}
export interface TaskProcessQueryBody {
  ret: number
  msg: string
  info: {
    [group_id: string]: TaskProcessQueryBodyInfo[]
  }
}

export interface TotalTaskProcessQueryBody {
  ret: number
  msg: string
  info: {
    task_info: TaskProcessQueryBodyInfo[]
    total_num: number
  }
}

export interface TaskProcQueryBodyRuleItemPresentItem {
  num: string
  product_item: {
    id: string
    name: string
    num: string
    url: string
    product_type: string
  }[]
}
export interface TaskProcQueryBodyRuleItem {
  begin_time: string
  end_time: string
  register_end_time: string
  task_id: string
  link: string
  title: string
  desc: string
  type: string
  circle_length_seconds: number
  allow_channel: string
  valid_time: string
  present_item: TaskProcQueryBodyRuleItemPresentItem[]
}
export interface TaskProcQueryBody {
  ret: number
  msg: string
  task_detail: {
    buytask: {
      task: {
        title: string
        rule_id: string
        rule_item: TaskProcQueryBodyRuleItem[]
      }
      ruleset_id: string
    }
  }
}

export function mobileSaveGoods(params: MobileSaveGoodsParams): Promise<MobileSaveGoodsResponseBody> {
  return new Promise((resolve, reject) => {
    const env = helper.getCgiEnv(params.sandbox)
    const rawData = {
      from_https: 1,
      from_h5: 1,
      pfkey: "pfkey"
    }

    const data = Object.assign(rawData, aes.encrypt(params, ["openid", "openkey", "session_id", "session_type"], !!params.sandbox), params)

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/${params.mid}/${params.offerId}/mobile_save_goods`,
        data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

interface FollowActivityCommonParams {
  openid: string
  openkey: string
  session_id: string
  session_type: string
  offerId: string
  wx_appid?: string
  qq_appid?: string
  pf: string
  pfkey: string
  from_https: number
  from_h5: number
}

export async function followActivity<T>(params: { sandbox: string; pf: string; offerId: string } & LoginSession): Promise<T> {
  return new Promise((resolve, reject) => {
    const env = helper.getCgiEnv(params.sandbox)

    const data: FollowActivityCommonParams = helper.extend(
      {
        pf: params.pf || "mds_wechat_qb-pay_html5.game-html5",
        pfkey: "pfkey",
        from_https: 1,
        from_h5: 1
      },
      params
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${data.offerId}/follow_activity`,
        data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res as T)
        } else {
          reject(res as T)
        }
      })
      .catch(reject)
  })
}

// 查询花花币进度
export function taskProcessQuery(
  params: LoginSession & {
    sandbox: string
    offerId: string
    drm_info: string
    task_id_list: string
  },
  options?: {
    timeout?: number
  }
): Promise<TaskProcessQueryBody> {
  return new Promise((resolve, reject) => {
    const { sandbox, offerId } = params
    const env = helper.getCgiEnv(sandbox)
    const _params = {
      from_https: 1,
      from_h5: 1,
      ...params,
      action: "task_process_query"
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerId}/accumulate_task`,
        data: {
          ..._params,
          ...aes.encrypt(_params, ["openid", "openkey", "session_id", "session_type"], !!sandbox)
        },
        timeout: options?.timeout || undefined
      })
      .then((res: TaskProcessQueryBody) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

// 查询档位
export function taskProcQuery(
  params: LoginSession & {
    sandbox: string
    offerid: string
    drm_info: string
  }
): Promise<TaskProcQueryBody> {
  return new Promise((resolve, reject) => {
    const { sandbox, offerid } = params
    const env = helper.getCgiEnv(sandbox)
    const _params = {
      from_https: 1,
      from_h5: 1,
      ...params,
      action: "get_task_detail"
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerid}/task_proc`,
        data: {
          ..._params,
          ...aes.encrypt(_params, ["openid", "openkey", "session_id", "session_type"], !!sandbox)
        }
      })
      .then((res: TaskProcQueryBody) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

// 查询充充币任务档位
export function ccbTaskProcQuery(
  params: LoginSession & {
    sandbox: string
    offerid: string
    drm_info: string
  }
): Promise<TaskProcQueryBody> {
  return new Promise((resolve, reject) => {
    const { sandbox, offerid } = params
    const env = helper.getCgiEnv(sandbox)
    const _params = {
      from_https: 1,
      from_h5: 1,
      ...params,
      action: "query_ccb_task_detail"
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerid}/accumulate_task`,
        data: {
          ..._params,
          ...aes.encrypt(_params as any, ["openid", "openkey", "session_id", "session_type"], !!sandbox)
        }
      })
      .then((res: TaskProcQueryBody) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

// 查询充充币进度
export function totalTaskProcessQuery(
  params: LoginSession & {
    sandbox: string
    offerId: string
    drm_info: string
    task_id_list: string
  }
): Promise<TotalTaskProcessQueryBody> {
  return new Promise((resolve, reject) => {
    const { sandbox, offerId } = params
    const env = helper.getCgiEnv(sandbox)
    const _params = {
      from_https: 1,
      from_h5: 1,
      ...params,
      action: "ccb_task_process_query"
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerId}/accumulate_task`,
        data: {
          ..._params,
          ...aes.encrypt(_params, ["openid", "openkey", "session_id", "session_type"], !!sandbox)
        }
      })
      .then((res: TotalTaskProcessQueryBody) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

// 领取任务奖励
export function getTaskPresent(params: {
  offerId: string
  sandbox: string
  userZone: UserZone
  userRole: UserRole
  presentRank: string
  loginState: LoginSession
  groupId: string
  taskId: string
  provide_no?: string
}): Promise<{ ret: number }> {
  return new Promise((resolve, reject) => {
    const { sandbox, offerId, taskId, loginState, groupId, userZone, userRole, presentRank } = params
    const env = helper.getCgiEnv(sandbox)
    const _params = {
      from_https: 1,
      from_h5: 1,
      action: "task_present",
      task_id: taskId,
      ...loginState,
      drm_info: `group_id=${groupId}&version=3.0`,
      present_rank: presentRank,
      gameid: [userZone?.partition_info?.area, userRole?.role_id, "", userZone?.partition_info?.partition].join("_"),
      game_platform_id: userZone?.partition_info?.game_platform_id || ""
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerId}/accumulate_task`,
        data: {
          ..._params,
          ...aes.encrypt(_params, ["openid", "openkey", "session_id", "session_type"], !!sandbox)
        }
      })
      .then((res: { ret: number }) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

// 获取新手任务
export function getNewbieTask(params: { offerId: string; sandbox: string; loginState: LoginSession; pf: string }): Promise<{
  ret: number
  info: { show_present: boolean; present_state: string; present_image: string; present_name: string; present_desc: string }
}> {
  return new Promise((resolve, reject) => {
    const { sandbox, offerId, loginState, pf } = params
    const env = helper.getCgiEnv(sandbox)
    const _params = {
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-${pf}-html5`,
      activity_id: "apple_product",
      action: "check_user_identity",
      ...loginState
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerId}/accumulate_task`,
        data: {
          ..._params,
          ...aes.encrypt(_params, ["openid", "openkey", "session_id", "session_type"], !!sandbox)
        }
      })
      .then((res: any) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}
//阶梯任务
export function getLadderTask(params: {
  offerId: string
  sandbox: string
  loginState: LoginSession
  pf: string
  taskId: string
  groupId: string
}): Promise<{
  ret: number
  info: any
}> {
  return new Promise((resolve, reject) => {
    const { sandbox, offerId, loginState, pf, taskId, groupId } = params
    const env = helper.getCgiEnv(sandbox)
    const _params = {
      from_https: 1,
      from_h5: 1,
      pf: `mds_wechat_qb-${pf}-html5`,
      activity_id: "apple_product",
      action: "query_ccb_present_info",
      task_id_list: taskId,
      drm_info: `group_id=${groupId}&version=3.0`,
      ...loginState
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerId}/accumulate_task`,
        data: {
          ..._params,
          ...aes.encrypt(_params, ["openid", "openkey", "session_id", "session_type"], !!sandbox)
        }
      })
      .then((res: any) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function fissionProc(
  { offerId, loginState, sandbox, pf = "applecard" }: { offerId: string; loginState: LoginSession; sandbox: string; pf: string },
  extendParams?: Record<string, any>
): Promise<any> {
  return new Promise((resolve, reject) => {
    const env = helper.getCgiEnv(sandbox)
    const params = {
      from_h5: 1,
      from_https: 1,
      pfkey: "pfkey",
      ...loginState,
      pf: `mds_wechat_qb-${pf}-html5`,
      ...extendParams
    }
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${offerId}/fission_proc`,
        data: {
          ...params,
          ...aes.encrypt(params, ["openid", "openkey", "session_id", "session_type"], !!sandbox)
        }
      })
      .then((res: { ret: number }) => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}
